<div class="modal" >
    <div class="eventmessage" cdkDrag>
           <a *ngIf="action=='done' || action=='alert' || action=='serie' || action=='info'" (click)='closeEvent($event)' class="button ghost close-icon">
               <i class="sprite-event-close" style="background:url('assets/img/close-black.svg')"></i>
           </a>
           
            <div>
                <div class="actions-content">
                    <span *ngIf="action=='done'" class="actions-icons">
                        <i style="background: url('assets/img/icon-success.svg') no-repeat; width:18px; height:18px; display:flex">
                        </i>
                    </span>
                    <span *ngIf="action=='alert' || action=='serie' " class="actions-icons">
                        <i style="background: url('assets/img/icon-warning-red.svg') no-repeat; width:18px; height:18px; display:flex">
                        </i>
                    </span>
                    <span *ngIf="action=='delete' || action=='info' " class="actions-icons">
                        <i style="background: url('assets/img/icon-warning.svg') no-repeat; width:18px; height:18px; display:flex">
                        </i>
                    </span>
                   
                    <h2>{{title}}</h2>
                </div>
                <!--<h2>{{title}}</h2>-->
                <div class="message-delete">
                    {{message}} 
                </div>
            </div>
         
            <div  class="buttons">
                <ng-container *ngIf="action=='delete'">
                    <button *ngIf="showNotifyButton" (click)="deleteEventWithNotify($event, true)" type="button" class="button button-accept">
                        <i class="sprite-event-check-white" style="background:url('assets/img/check.svg')"></i>
                        <span>Aceptar y notificar</span>
                    </button>
                    <!--
                    <button (click)="deleteEventWithNotify($event, true)" type="button" class="button button-accept">
                        <i class="sprite-event-check-white" style="background:url('assets/img/check.svg')"></i>
                        <span>Aceptar y notificar</span>
                    </button>
                    -->
                    <button (click)="deleteEventWithNotify($event, false)" type="button" class="button button-accept">
                        <i class="sprite-event-check-white" style="background:url('assets/img/check.svg')"></i>
                        <span>Aceptar</span>
                    </button>
                    <button (click)="cancelEvent($event)" type="button" class="button button-cancel">
                        <i class="sprite-event-check-white" style="background:url('assets/img/close.svg')"></i>
                        <span>Cancelar</span>
                    </button>
                </ng-container>

                <ng-container *ngIf="action!='delete'">
                    <button *ngIf="action=='update'" (click)="confirmEvent($event)"  type="submit" class="button button-accept">
                        <i class="sprite-event-check-white" style="background:url('assets/img/check.svg')"></i>
                        <span>Aceptar</span>
                    </button>
                    <button *ngIf="action=='' || action=='update'"  (click)="cancelEvent($event)"  type="submit" class="button button-cancel">
                        <i class="sprite-event-check-white" style="background:url('assets/img/close.svg')"></i>
                        <span>Cancelar</span>
                    </button>
                </ng-container>
            </div>
     </div>
</div>
